// extracted by mini-css-extract-plugin
export var shake = "_a-1";
export var toastCloseButton = "_a-0";